import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lock_icon = _resolveComponent("lock-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_send_icon = _resolveComponent("send-icon")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createBlock(_component_n_space, { class: "response-actions-spacing" }, {
    default: _withCtx(() => [
      _createVNode(_component_n_button, {
        type: "primary",
        onClick: _ctx.unlockResponse,
        "aria-label": "Unlock Form",
        disabled: _ctx.unlocked
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_n_icon, { "aria-hidden": "true" }, {
            default: _withCtx(() => [
              _createVNode(_component_lock_icon)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(" Unlock ")
        ]),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _createVNode(_component_n_button, {
        type: "primary",
        onClick: _ctx.resendResponse,
        "aria-label": "Resend Form",
        disabled: !_ctx.unlocked
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_n_icon, { "aria-hidden": "true" }, {
            default: _withCtx(() => [
              _createVNode(_component_send_icon, { alt: "" })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(" Resend ")
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _: 1
  }))
}